(() => {
  const normalize = (value) => value.toLocaleLowerCase('de').replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  const near = (word, candidate) => {
    if (word.length < 5 || Math.abs(word.length - candidate.length) > 1) return false;
    let row = Array.from({ length: candidate.length + 1 }, (_, i) => i);
    for (let i = 0; i < word.length; i++) {
      const next = [i + 1];
      for (let j = 0; j < candidate.length; j++) next[j + 1] = Math.min(next[j] + 1, row[j + 1] + 1, row[j] + Number(word[i] !== candidate[j]));
      row = next;
    }
    return row[candidate.length] <= 1;
  };
  const chatNodes = () => {
    const host = document.querySelector('shopify-chat');
    if (!host) return [];
    const nodes = [];
    const visit = (root) => {
      for (const node of root.querySelectorAll('*')) {
        nodes.push(node);
        if (node.shadowRoot) visit(node.shadowRoot);
      }
    };
    if (host.shadowRoot) visit(host.shadowRoot);
    return nodes;
  };
  let opening;
  const watchChat = (root) => {
    const started = Date.now();
    const check = () => {
      const nodes = chatNodes();
      const host = document.querySelector('shopify-chat');
      const isOpen = host?.open === true || host?.hasAttribute('open') || nodes.some((node) => node.tagName === 'SHOPIFY-AGENT-RUNTIME' && node.hasAttribute('open'));
      if (!isOpen) return;
      const unavailable = nodes.find((node) => node.getAttribute('role') === 'alert' && node.getBoundingClientRect().width > 0 && /chat/.test(node.textContent.toLocaleLowerCase('de')));
      if (unavailable) {
        root.querySelector('[data-support-chat-status]').textContent = root.dataset.chatUnavailable;
        if (typeof host?.close === 'function') host.close();
        else {
          const close = nodes.find((node) => node.tagName === 'BUTTON' && /^(chat schliessen|close chat)$/.test(normalize(node.getAttribute('aria-label') || '')));
          close?.click();
        }
        return;
      }
      if (Date.now() - started < 45000) window.setTimeout(check, 500);
    };
    check();
  };
  const openChat = async (root, userInitiated = false) => {
    if (opening) return opening;
    const status = root.querySelector('[data-support-chat-status]');
    opening = (async () => {
      const started = Date.now();
      let clicked = false;
      while (Date.now() - started < 8000) {
        const host = document.querySelector('shopify-chat');
        const nodes = chatNodes();
        const expanded = nodes.find((node) => node.tagName === 'BUTTON' && node.getAttribute('aria-expanded') === 'true' && /chat/i.test(node.getAttribute('aria-label') || ''));
        const runtimeOpen = nodes.some((node) => node.tagName === 'SHOPIFY-AGENT-RUNTIME' && node.hasAttribute('open'));
        if (host?.open === true || host?.hasAttribute('open') || expanded || runtimeOpen) { status.textContent = ''; if (clicked) watchChat(root); return true; }
        if (typeof host?.show === 'function' && !clicked) { host.show(); clicked = true; }
        const launcher = nodes.find((node) => node.tagName === 'BUTTON' && node.getAttribute('aria-expanded') === 'false' && /chat.*(oeffnen|offnen|open)/.test(normalize(node.getAttribute('aria-label') || '')));
        if (launcher && !clicked && launcher.getBoundingClientRect().width > 0) { launcher.click(); clicked = true; }
        await new Promise((resolve) => window.setTimeout(resolve, 250));
      }
      status.textContent = root.querySelector('[data-support-fallback]').textContent;
      if (userInitiated) root.querySelector('[data-support-chat]').focus({ preventScroll: true });
      return false;
    })();
    try { return await opening; } finally { opening = undefined; }
  };
  const setup = (root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const input = root.querySelector('[data-support-search]');
    const results = root.querySelector('[data-support-results]');
    const list = root.querySelector('[data-support-matches]');
    const empty = root.querySelector('[data-support-empty]');
    const count = root.querySelector('[data-support-count]');
    const index = JSON.parse(root.querySelector('[data-support-index]').textContent).map((item) => ({ ...item, titleText: normalize(item.title), words: normalize(`${item.title} ${item.keywords}`).split(' ') }));
    input.addEventListener('input', () => {
      const query = normalize(input.value).slice(0, 120);
      results.hidden = !query;
      list.replaceChildren();
      if (!query) { count.textContent = ''; empty.hidden = true; return; }
      const tokens = query.split(' ').filter((word) => !['ich', 'meine', 'mein', 'ist', 'die', 'der', 'das', 'ein', 'eine', 'wie', 'kann', 'wo', 'und', 'zu', 'mit', 'es', 'ihr'].includes(word));
      const activeTokens = tokens.length ? tokens : [query];
      const matches = index.map((item) => ({ item, score: activeTokens.reduce((score, token) => score + (item.titleText.includes(token) ? 5 : item.words.some((word) => word.startsWith(token) || (word.length >= 5 && token.startsWith(word))) ? 3 : item.words.some((word) => near(token, word)) ? 1 : -100), 0) })).filter(({score}) => score > 0).sort((a,b) => b.score - a.score);
      count.textContent = `${matches.length} ${root.dataset.resultLabel}`;
      empty.hidden = matches.length > 0;
      for (const {item} of matches) {
        const row = document.createElement('li');
        const link = document.createElement('a');
        link.href = item.url;
        link.dataset.supportResult = '';
        const title = document.createElement('span');
        title.textContent = item.title;
        const category = document.createElement('small');
        category.textContent = item.category;
        link.append(title, category);
        row.append(link);
        list.append(row);
      }
    });
    for (const button of root.querySelectorAll('[data-support-chat]')) button.addEventListener('click', () => openChat(root, true));
  };
  document.querySelectorAll('[data-mo-support]').forEach(setup);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-mo-support]').forEach(setup));
})();
